import { useToast as useToastification } from "vue-toastification";

type ToastMessage = {
  severity?: "success" | "info" | "warn" | "error";
  summary?: string;
  detail?: string;
  life?: number;
};

export function useToast() {
  const toast = useToastification();

  return {
    add(message: ToastMessage) {
      const severity = message.severity || "info";
      const method = severity === "warn" ? "warning" : severity;
      const content = message.detail
        ? `${message.summary || ""}\n${message.detail}`.trim()
        : message.summary || "";

      toast[method](content, {
        timeout: message.life || 2500,
      });
    },
  };
}
